// extracted by mini-css-extract-plugin
module.exports = {"ScrollList":"AddOnSlider-ScrollList-3mSPZa","Header":"AddOnSlider-Header-3l251x","ScrollListItem":"AddOnSlider-ScrollListItem-3M-Vww"};